import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const BillingDashboard = lazy(() => import('./pages/BillingDashboard'));
const BillingPricing = lazy(() => import('./pages/BillingPricing'));
const BillingMonthlyGrid = lazy(() => import('./pages/BillingMonthlyGrid'));
const BillingDormantStores = lazy(() => import('./pages/BillingDormantStores'));
const BillingContracts = lazy(() => import('./pages/BillingContracts'));

export const billingRoutes: RouteObject = {
  path: 'billing',
  handle: { breadcrumb: 'Billing' },
  children: [
    { index: true, element: <BillingDashboard />, handle: { breadcrumb: 'Dashboard' } },
    { path: 'grid', element: <BillingMonthlyGrid />, handle: { breadcrumb: 'Monthly grid' } },
    {
      path: 'dormant',
      element: <BillingDormantStores />,
      handle: { breadcrumb: 'Dormant stores' },
    },
    { path: 'pricing', element: <BillingPricing />, handle: { breadcrumb: 'Pricing config' } },
    { path: 'contracts', element: <BillingContracts />, handle: { breadcrumb: 'Contracts' } },
  ],
};
